export const playersColors = [
    'green',
    'purple',
    'red',
    'blue',
    'orange',
    '#00e2ff',
];